import { Box, Grid } from "@mui/material";
import { IARDashboardNumbers } from "../../utils/ARDashboard.types";
import { Utils } from "../../utils/common-utils";
import OutlinedCard from "./Card";

const DashboardCards = (props: {
  details?: IARDashboardNumbers
}) => {

  const { details } = props;

  return (
    <>
      <Box sx={{ flexGrow: 1, mb: '50px' }}>
        <Grid container sx={{ mb: '10px' }} spacing={{ xs: 2, md: 6 }} columns={{ xs: 6, sm: 6, md: 12 }}>
          <Grid item xs={12} sm={2} md={4}>
            <OutlinedCard
              id='1'
              backgroundColor='rgb(58, 155, 252)'
              title='Total Customers'
              value={details?.totalCustomers}
              maxWidth='500px'
              borderRadius='5px'
              paddingLeft='18px'
              paddingRight='18px'
              paddingTop='5px'
              textAlignVertical='center'
              height='90px' />
          </Grid>
          <Grid item xs={12} sm={2} md={4}>
            <OutlinedCard
              id='2'
              backgroundColor='rgb(107, 199, 190)'
              title='AR'
              value={Utils.formatNumber(details?.totalAR, true, false)}
              maxWidth='500px'
              borderRadius='5px'
              paddingLeft='18px'
              paddingRight='18px'
              paddingTop='5px'
              textAlignVertical='center'
              height='90px' />
          </Grid>
          <Grid item xs={12} sm={2} md={4}>
            <OutlinedCard
              id='3'
              backgroundColor='rgb(15, 15, 15)'
              title='AP'
              value={Utils.formatNumber(details?.totalAP, true, false)}
              maxWidth='500px'
              borderRadius='5px'
              paddingLeft='18px'
              paddingRight='18px'
              paddingTop='5px'
              textAlignVertical='center'
              height='90px' />
          </Grid>

          <Grid item xs={12} sm={2} md={4}>
            <OutlinedCard
              backgroundColor='rgb(58, 155, 252)'
              title='Total Vendors'
              value={details?.totalVendors}
              maxWidth='500px'
              borderRadius='5px'
              paddingLeft='18px'
              paddingRight='18px'
              paddingTop='5px'
              textAlignVertical='center'
              height='90px' />
          </Grid>
          <Grid item xs={12} sm={2} md={4}>
            <OutlinedCard
              backgroundColor='rgb(107, 199, 190)'
              title='DSO'
              value={Utils.formatNumber(details?.totalARDSO, false, false) + ' days'}
              maxWidth='500px'
              borderRadius='5px'
              paddingLeft='18px'
              paddingRight='18px'
              paddingTop='5px'
              textAlignVertical='center'
              height='90px' />
          </Grid>
          <Grid item xs={12} sm={2} md={4}>
            <OutlinedCard
              backgroundColor='rgb(15, 15, 15)'
              title='DPO'
              value={Utils.formatNumber(details?.totalAPDSO, false, false) + ' days'}
              maxWidth='500px'
              borderRadius='5px'
              paddingLeft='18px'
              paddingRight='18px'
              paddingTop='5px'
              textAlignVertical='center'
              height='90px' />
          </Grid>
        </Grid>
      </Box>
    </>
  )
}

export default DashboardCards;